// Refactored and sectioned PayoutMethod page
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { AppBarBackLinkHandler, AppBarTitleHandler } from "../../store/AppBarSlice";
import { updatePayoutMethod } from "../../store/PayoutSlice";
import Button from "../../components/Button/Button";
import DefaultInput from "../../components/DefaultInput/DefaultInput";
import ExitPopup from "../../components/Popups/ExitPopup/ExitPopup";
import classes from "./PayoutMethod.module.css";
import { getNextPayoutDate } from "../../utils/utils";

const businessFields = [
  { name: "legalBusinessName", label: "Legal Business Name" },
  { name: "businessType", label: "Business Type (e.g. Private Limited)" },
  { name: "taxNumber", label: "Tax Number (if applicable)" },
  { name: "businessAddress", label: "Business Address" },
  { name: "businessWebsiteUrl", label: "Business Website URL" },
  { name: "businessContactEmail", label: "Business Contact Email" },
  { name: "businessPhoneNumber", label: "Business Phone Number (Incl. international dialling code)" },
];

const bankFields = [
  { name: "bankCountry", label: "Bank Country" },
  { name: "accountName", label: "Account Holder Name" },
  { name: "swiftCode", label: "BIC/SWIFT Code" },
  { name: "accountNumber", label: "IBAN / Account Number" },
  { name: "bankName", label: "bank Name" },
];

const personalFields = [
  { name: "fullName", label: "Full name (First name and Surname)" },
  { name: "dateOfBirth", label: "Date of Birth" },
  { name: "email", label: "Email" },
  { name: "phoneNumber", label: "Phone Number (incl. International Dialling Code)" },
  { name: "address", label: "Address" },
];

const allFields = [...businessFields, ...bankFields, ...personalFields];

export const PayoutMethod = () => {
  const { payoutData } = useSelector((state) => state.payoutData);
  const [buttonStatus, setButtonStatus] = useState("disabled");
  const [validateOnChange, setValidateOnChange] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AppBarTitleHandler("Payout method"));
    dispatch(AppBarBackLinkHandler("/"));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: allFields.reduce((acc, { name }) => ({ ...acc, [name]: payoutData?.[name] || "" }), {}),
    enableReinitialize: true,
    validateOnChange,
    validateOnBlur: false,
    onSubmit: (values) => handleFormSubmit(values),
  });

  const handleFormSubmit = (values) => {
    setButtonStatus("submitting");
    dispatch(updatePayoutMethod(values)).then(({ meta }) => {
      setButtonStatus(meta.requestStatus === "fulfilled" ? "disabled" : "active");
    });
  };

  const handleChange = (e) => {
    setButtonStatus("active");
    formik.handleChange(e);
  };

  const renderInputs = (fields) =>
    fields.map(({ name, label }) => (
      <div className={classes.input} key={name}>
        <DefaultInput
          inputName={name}
          name={label}
          value={formik.values[name]}
          onChange={handleChange}
          hasError={formik.errors[name]}
          errorMessage={formik.errors[name]}
          maxLength={100}
        />
      </div>
    ));

  return (
    <>
      <div className={classes.payout}>
        <div className={classes.container}>
          <h2>Bank details</h2>
          <p>
            Your cash balance will be paid out to this bank account once per month.
            <span> Next payout date:</span> {getNextPayoutDate().month} 1, {getNextPayoutDate().year}
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit();
              setValidateOnChange(true);
            }}
          >
            <h4>Business Information</h4>
            {renderInputs(businessFields)}

            <h4>Bank Account Details</h4>
            {renderInputs(bankFields)}

            <h4>Personal Information</h4>
            {renderInputs(personalFields)}

            <Button text="Save" status={buttonStatus} />
          </form>
        </div>
      </div>
      <ExitPopup saveHandler={formik.handleSubmit} hasError={!formik.isValid} buttonStatus={buttonStatus} />
    </>
  );
};
